import { NavLink } from 'react-router-dom';

export function AuthTabs() {
  const base =
    'flex-1 rounded-full px-4 py-2 text-center text-sm font-medium transition';
  const active = 'bg-white text-slate-900 shadow-sm';
  const inactive = 'text-slate-500 hover:text-slate-700';

  return (
    <div className="inline-flex w-full max-w-xs rounded-full border border-slate-200 bg-slate-50 p-1">
      <NavLink
        to="/login"
        className={({ isActive }) => `${base} ${isActive ? active : inactive}`}
      >
        Sign in
      </NavLink>
      <NavLink
        to="/signup"
        className={({ isActive }) => `${base} ${isActive ? active : inactive}`}
      >
        Create account
      </NavLink>
    </div>
  );
}
